export const L5RadioButtonSize = {
    SM: 'sm',
    MD: 'md',
    LG: 'lg',
};
